<template>
  <div class="container myWelfare" :data-corp-id="colorCorpId">
     <ul>
       <li class="welfare_item" v-for="item in myWelfare.notGet" @click="toPackage(item)">
         <div class="img_box"><img :src="item.cover" alt=""></div>
         <div class="infos">
           <dl>
             <dt>{{item.title}}</dt>
             <dd>领取截止日期：{{item.endDate}}</dd>
           </dl>
           <div class="btn_wrap">
             <a href="javascript:;" class="btn btn-default" v-if="item.status==3" @click.stop="toOrder(item)">领取福利</a>
             <a href="javascript:;" class="btn btn-line" v-if="item.status==1" @click.stop="toPackage(item)">
              查看福利
            </a>
            <a href="javascript:;" class="btn btn-line" v-if="item.status==6" @click.stop="toOrder(item)">
              已过期
            </a>
           </div>
            
         </div>
       </li>
       <li class="welfare_item" v-for="item in myWelfare.hasGet">
         <div class="img_box"><img :src="item.cover" alt=""></div>
         <div class="infos">
           <dl>
             <dt>{{item.title}}</dt>
             <dd>领取截止日期：{{item.endDate}}</dd>
           </dl>
           <div class="btn_wrap">
             <a href="javascript:;" class="btn btn-default" v-if="item.status==3" @click.stop="toOrder(item)">领取福利</a>
            
             <a href="javascript:;" class="btn btn-line mywelfare" v-if="item.orderId" @click.stop="toOrder(item)">
              订单详情
            </a>
            <a href="javascript:;" class="btn btn-line mywelfare" v-if="item.status==1" @click.stop="toPackage(item)">
              福利介绍
            </a>
            <a href="javascript:;" class="btn btn-line" v-if="item.status==6" @click.stop="toOrder(item)">
              已过期
            </a>
           </div>
            
         </div>
       </li>
     </ul>
     <div class="no-data" v-if="!loading&&myWelfare.notGet.length==0&&myWelfare.hasGet.length==0">
         <p>暂无福利</p>
      </div>
      
        <tipDialog :showStatus='showTip' :tipText='tipText' @close="closeTipDialog"></tipDialog>
        <home :ishome=0></home>
  </div>
</template>
<script>
import {
    mapGetters,
    mapActions
} from 'vuex'
import Cookies from 'js-cookie'
import tipDialog from '../common/tipDialog.vue'
import home from '../common/home.vue'

export default {
  data () {
    return {
     	 hasGetw:true,
       loading:true,
       showTip:0,
       tipText:''
    }
  },
  components:{
    tipDialog,
    home
  },
  computed:{   	 	 
  	 ...mapGetters({
      myWelfare:'getmyWelfare',
      corpId:'getcorpId',
      isShowMergeNav:'getisShowMergeNav',
      getUserInfo: 'getUserInfo',
    }),
    colorCorpId(){
      return this.getUserInfo.corpId || '';
    },
     queryCorpId(){
      return this.$route.query.corpId;
     }
  },
  watch:{
    myWelfare(cval){
      if(cval){
        this.loading=false
      }
    },
    'corpId':{
      handler: function (val, oldVal) {
        if(typeof val == 'number'){
          console.log("corpid",val)
          this.$store.dispatch('loadMyWelfare',{currentPage:1,totalPage:0})
        }else{
          this.showTip=1;
          this.tipText=val;
        }
     },
          deep: true
    },
    
  },
  created(){
    // this.$store.dispatch('userSectionCheck')
    if(!this.queryCorpId){
      this.$store.dispatch('loadMyWelfare',{currentPage:1,totalPage:0})
    }
  },
  methods:{
    toOrder(data){
      window.location.href = data.orderUrl
    },
    closeTipDialog(status){
      this.showTip=status;
    },
    toPackage(data){
      window.location.href = data.clickUrl
    }
  },
  mounted(){
  }
}
</script>